"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VEHICLES_MAP = void 0;

function _instanceof(left, right) {
  if (
    right != null &&
    typeof Symbol !== "undefined" &&
    right[Symbol.hasInstance]
  ) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var VEHICLES_MAP = [
  { code: "EL",      guid: "jtdcya1293qe6i58kntpa"},
  { code: "EL-L",    guid: "ykjst8lqzbjord0abnp5"},
  { code: "ELL",     guid: "sf4a70wh3qjn75xc9lethv"},
  { code: "RN",      guid: "jy8l20d1daix4ta9els70b"},
  { code: "RN-SUV",  guid: "fb9771d989e34fe098993f"},
  { code: "ZC",      guid: "vde9y7wnb1d9d8xdyjo67r"},
  { code: "NS",      guid: "ohiwuwrgvyma9ez12a1eq"},
  { code: "RE",      guid: "q45d33ftgbh90embojmu0p"},
  { code: "REE",     guid: "k1igxci6o24dxl9v13r20b"},
  { code: "RE-PHEV", guid: "ifx1mxp53x8b3nj58qgon"},
  { code: "NSE",     guid: "yqk8vhvhs01eoh2mlwx0xv"},
  { code: "DG",      guid: "bjp0e8elcw88ozs2ddv17l"},
  { code: "DGE",     guid: "xoiookxoaw0tizqht2jf3z"},
  { code: "QX",      guid: "94y6pjmgegojtwhtjezx9"},
  { code: "BK",      guid: "w1wxnedsanmo1cqof7gs5u"},
  // { code: "SU",      guid: "os0spbk64qr4mbtxno7g8v"},
  { code: "SU",      guid: "p53m5e81u0rgfxtut7n1x4"},
  { code: "TS",      guid: "bf0ue20w7zu0sod4dri3o1"},
  { code: "TK",      guid: "kegoq67qn22thob4emvm0l"},
  { code: "RG-MiEV", guid: "lsrraerzhs1hsh5c0u9im4"},
  { code: "TQ-MiEV", guid: "z9x94ybbkeqym2hru16h9"},
  { code: "GSX",     guid: "lm240fu9mj0defnpzznafa"},
  { code: "GS44S",   guid: "lqydtyr1iyfjjzfavixduo"},
  { code: "GS41",    guid: "gw3m511pe9hhrw6szk6lha"},
  { code: "VS",      guid: "bf0ue20w7zu0sod4dri3o1"},
  { code: "VSE",     guid: "pqe2mem4nd8ud0hqry2vc9"},
  { code: "VB",      guid: "bijs20qjk6bol3ez9dkl8k"},
  { code: "UT",      guid: "v69hp7xnpiw593ff5ff6zp"},
  { code: "RNE",     guid: "ueqfgnq0k696t7io7n16tg"},
  { code: "RNE-SUV", guid: "g0cbjxulr63ox2m0k1ngk3"},
  { code: "RNE-MPV", guid: "iguoq7be5l14lrsg7jwxuu"},
  { code: "RV",      guid: "l7rodixnxtadjpw2fytbbx"},
  { code: "RVE",      guid: "nf8fp2saq48hx6zuc2t459"}
];
exports.VEHICLES_MAP = VEHICLES_MAP;

var lookupByKey = function lookupByKey(options) {
  var lookupBy = options.lookupBy,
    dataKey = options.dataKey,
    matcher = options.matcher,
    dataMap = options.dataMap;
  var data;
  dataMap.forEach(function(obj) {
    if (obj[lookupBy] === matcher) {
      data = obj[dataKey];
    }
  });
  return data;
};

var VehicleCodeUtilityClass = function VehicleCodeUtilityClass(vehiclesMap) {
  var _this = this;

  _classCallCheck(this, VehicleCodeUtilityClass);

  _defineProperty(this, "getVehicleByGuid", function(guid) {
    return lookupByKey({
      lookupBy: "guid",
      dataKey: "code",
      matcher: guid,
      dataMap: _this.vehiclesMap
    });
  });

  _defineProperty(this, "getVehicleByCode", function(vehicleCode) {
    return lookupByKey({
      lookupBy: "code",
      dataKey: "guid",
      matcher: vehicleCode,
      dataMap: _this.vehiclesMap
    });
  });

  this.vehiclesMap = vehiclesMap;
}; // console.log(
//   `${util.getVehicleByGuid("vde9y7wnb1d9d8xdyjo67r")}
// ${util.getVehicleByCode("SU")}`
// );

exports.default = VehicleCodeUtilityClass;
